let LocationFlyout = (function () {
    let init = function () {
        LocationFlyout.bindEvents();
        LocationFlyout.initAutoComplete();
    }

    let initAutoComplete = function () {
        let input = document.getElementsByClassName('location-flyout-input');

        for (var i = 0; i < input.length; i++) {
            let autocomplete = new google.maps.places.Autocomplete(input[i], {
                types: ['geocode']
            });
            let field = input[i];
            google.maps.event.addListener(autocomplete, 'place_changed', () => {
                let place = autocomplete.getPlace();
                if (place) {
                    jQuery(field).closest("form").submit();
                }
            });
        }
    }

    let bindEvents = function () {
        LocationFlyout.flyoutToggle();
    }

    let lookupDayOfWeek = (selector, fullString) => {
        var weekArr = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        var weekArrFull = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var date = new Date();
        var currentDay = date.getDay();

        jQuery(selector).each(function () {
            var text = jQuery(this).text();
            var searchArray = weekArr;

            if (text.indexOf("-") >= 0) {
                var days = text.split("-");
                if (fullString) {
                    searchArray = weekArrFull
                }
                var lowerBound = LocationFlyout.arraySearchForKey(searchArray, days[0]);
                var upperBound = LocationFlyout.arraySearchForKey(searchArray, days[1]);
                if (currentDay >= lowerBound && currentDay <= upperBound) {
                    jQuery(this).parent().addClass('active-day');
                }
            } else {
                if (searchArray[currentDay].match(text)) {
                    jQuery(this).parent().addClass('active-day');
                }
            }

        });
    }

    let arraySearchForKey = function (arr, val) {
        for (var i = 0; i < arr.length; i++)
            if (arr[i] === val)
                return i;
        return false;
    }

    let flyoutToggle = function () {
        
        jQuery(document).click(function() {
            if( (jQuery(".navbar-right-widget .flyout-expanded").hasClass("flyout-active")) || (jQuery(".mobile-location-flyout-container .location-flyout-address").hasClass("flyout-active")) ){
                LocationFlyout.changeCaret(jQuery(".location-flyout-address.flyout-active"));
                jQuery(".location-flyout-address.flyout-active").toggleClass("flyout-active");
                jQuery(".flyout-expanded.flyout-active").toggleClass("flyout-active");
            }
        });

        jQuery(".flyout-expanded").click(function(e) {
            e.stopPropagation();
        });

        // don't want to bind twice, component rendering on mobile makes this unbind and bind necessary
        jQuery(".location-flyout-address").unbind("click").click(function (e) {
            e.stopPropagation();
            LocationFlyout.lookupDayOfWeek('li > div.flyout-store-day', true);
            LocationFlyout.changeCaret(jQuery(this));
            jQuery(this).toggleClass("flyout-active");
            jQuery(this).parent().siblings(".flyout-expanded").toggleClass("flyout-active");
        });
    }

    let changeCaret = function (element) {
        var faElement = element.find(".dropdown-caret");

        if (faElement.hasClass("fa-caret-down")) {
            faElement.removeClass("fa-caret-down");
            faElement.addClass("fa-caret-up");
            return;
        }

        if (faElement.hasClass("fa-caret-up")) {
            faElement.removeClass("fa-caret-up");
            faElement.addClass("fa-caret-down");
            return;
        }

    }

    return {
        init: init,
        bindEvents: bindEvents,
        flyoutToggle: flyoutToggle,
        lookupDayOfWeek: lookupDayOfWeek,
        arraySearchForKey: arraySearchForKey,
        changeCaret: changeCaret,
        initAutoComplete: initAutoComplete
    }
})();